module.exports = __webpack_public_path__ + "static/icons/icon-flights-25e4646d6b24636e7bfc0745b281eb61.svg";